import { render, staticRenderFns } from "./ToProcessed.vue?vue&type=template&id=10ede024&scoped=true&"
import script from "./ToProcessed.vue?vue&type=script&lang=js&"
export * from "./ToProcessed.vue?vue&type=script&lang=js&"
import style0 from "./ToProcessed.vue?vue&type=style&index=0&id=10ede024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ede024",
  null
  
)

export default component.exports